import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const groupPharmacyEditRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/pharmacies/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/group/Pharmacies/GroupPharmacyEditPage/GroupPharmacyEditPage').then((d) => d.Route)
);
